module.exports = __webpack_public_path__ + "img/appLogo-color--Onlight-variant.d6f5804b.svg";